import { Page } from "../../components/layout/Page"
import { SearchBar } from "./searchBar"
import PlayerFilters from "./playersFilters/PlayersFilters"
import PlayerList from "./playerList/PlayerList"
import { useCallback, useEffect, useState } from "react"
import { usePlayers, usePlayersTotal } from "./lib/players"
import { useBottomReachedDetector } from "../../lib/infinit-scroll"
import { uniqBy } from "lodash"
import { useStorePlayers } from "./store"
import { useStoreShared } from "../../store"
import { setCurrentQuickSearch, setLengthPlayer, setPlayersList } from "./store/actions"
function Players() {
  const [page, setPage] = useState(1)
  const { statePlayers, dispatchPlayers } = useStorePlayers()
  const { stateShared } = useStoreShared()
  const [params, setParams] = useState({
    $page: page,
    $length: 25,
    isDefault: true,
    quickSearch: statePlayers.currentQuickSearch ?? "",
    online: "all",
  })
  const [players, , loadingList] = usePlayers(stateShared.currentClient?.uuid, params)
  const [playersTotal, , ,] = usePlayersTotal(stateShared.currentClient?.uuid)
  let timer: any
  let currentQuickSearch: string
  const onReached = useCallback(() => {
    if (!loadingList && !checkListLength()) {
      setPage((page) => 1 + page)
    }
  }, [loadingList])

  useBottomReachedDetector({
    bottomOffset: 100,
    onReached,
  })
  function checkListLength(): boolean {
    if (params.online === "all") {
      return params.$page * 25 > statePlayers.lengthPlayer?.all
    }
    if (params.online) {
      return params.$page * 25 > statePlayers.lengthPlayer?.online
    } else {
      return params.$page * 25 > statePlayers.lengthPlayer?.off
    }
  }
  function updateFilter(data: string) {
    if (data !== params.online) {
      const online = { online: data }
      const page = { $page: 1 }
      setPage(1)
      dispatchPlayers(setPlayersList([]))
      setParams((params) => ({
        ...params,
        ...page,
        ...online,
      }))
    }
  }

  function updateQuickSearch(data: any) {
    if (currentQuickSearch !== data) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        currentQuickSearch = data
        dispatchPlayers(setCurrentQuickSearch(currentQuickSearch))
        const quickSearch = { quickSearch: data, $page: 0 }
        setParams((params) => ({
          ...params,
          ...quickSearch,
        }))
        dispatchPlayers(setPlayersList([]))
      }, 700)
    }
  }

  useEffect(() => {
    setParams((params) => ({
      ...params,
      $page: page,
    }))
  }, [page])
  useEffect(() => {
    //  retry();
  }, [params])

  useEffect(() => {
    dispatchPlayers(
      setLengthPlayer({
        all: parseInt(playersTotal.audio) + parseInt(playersTotal.video),
        off: parseInt(playersTotal.audioOffline) + parseInt(playersTotal.videoOffline),
        online: parseInt(playersTotal.audioOnline) + parseInt(playersTotal.videoOnline),
      })
    )
  }, [playersTotal])

  useEffect(() => {
    if (players.length > 0) {
      dispatchPlayers(setPlayersList(uniqBy([...statePlayers.players, ...players], "deviceID")))
    }
  }, [players])

  return (
    <Page>
      <SearchBar quickSearch={updateQuickSearch}></SearchBar>
      <PlayerFilters total={statePlayers.lengthPlayer} filter={updateFilter}></PlayerFilters>
      <PlayerList players={statePlayers.players}></PlayerList>
    </Page>
  )
}

export default Players
